module.exports = __webpack_public_path__ + "img/box8-1.d2d70f76.png";